module.exports = __webpack_public_path__ + "static/media/linuxmint_overlay-fs8.18c0bff8.png";